import { render } from "./Screening.vue?vue&type=template&id=0dcdff89&scoped=true"
import script from "./Screening.vue?vue&type=script&lang=js"
export * from "./Screening.vue?vue&type=script&lang=js"

import "./Screening.vue?vue&type=style&index=0&id=0dcdff89&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcdff89"]])

export default __exports__